import React, { useState, useEffect } from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import * as TbIcons from 'react-icons/tb';
import * as AiIcons from 'react-icons/ai';
import FileService from "../services/file.service";
import AuthService from "../services/auth.service";
import AxiosService from "../services/axios.service";
import Multiselect from 'multiselect-react-dropdown';
import AsyncSelect from 'react-select/async';
import $ from "jquery"
const API_PATH = "requests";

function AddEditRequest({ history, match }) {

    // file upload constants
    const [selectedFiles, setSelectedFiles] = useState(undefined);
    const [currentFile, setCurrentFile] = useState(undefined);
    const [progress, setProgress] = useState(0);
    const [message, setMessage] = useState("");
    const [documents, setDocuments] = useState([]);
    const [fileInfos, setFileInfos] = useState([]);
    const FILES_URL = "https://db.irli.org:8080/api/files/";
    const [mod, setMod] = useState(false);
    const [admin, setAdmin] = useState(false);
    const [selectedAgency, setSelectedAgency] = useState(null);
    const [contactOptions, setContactOptions] = useState([]);
    const [selectedValueContact, setSelectedValueContact] = useState([]);
    const [contacts, setContacts] = useState([]);

    // handle input change event
    const handleInputChange = value => {

    };

    // handle selection
    const handleChange = value => {
        setSelectedAgency(value);
        setValue("agency", value.name);
        console.log("value: " + value.name)
    }

    function onSelectContact(selectedList, selectedItem) {
        setContacts(selectedList);
    }

    function onRemoveContact(selectedList, removedItem) {
        setContacts(selectedList);
    }

    const selectFile = (event) => {
        setSelectedFiles(event.target.files);
    };

    const upload = () => {
        let currentFile = selectedFiles[0];
        setProgress(0);
        setCurrentFile(currentFile);

        FileService.upload(currentFile, (event) => {
            setProgress(Math.round((100 * event.loaded) / event.total));
        })
            .then((response) => {
                setMessage(response.data.message);
                documents.push(currentFile.name);
                setDocuments(documents);
                var files = [];
                for (var x in documents) {
                    var file = new Object();
                    file.name = documents[x];
                    file.url = FILES_URL + file.name;
                    files.push(file);
                }
                setFileInfos(files);
            })
            .catch(() => {
                setProgress(0);
                setMessage("Could not upload the file!");
                setCurrentFile(undefined);
            });
        setSelectedFiles(undefined);
    };

    const { id } = match.params;
    const isAddMode = !id;
    // form validation rules
    const validationSchema = Yup.object().shape({
        agency: Yup.string()/*.required('Agency is required')*/,
        agency_tracking_numbers: Yup.string(),
        current_status: Yup.string(),
        category: Yup.string().required('Category is required'),
        subject: Yup.string(),
        short_description: Yup.string(),
        submission_date: Yup.string(),
        response_limit: Yup.string(),
        acknowledgement_date: Yup.string(),
        response_deadline: Yup.string(),
        expected_response_date: Yup.string(),
        appeal_limit: Yup.string(),
        appeal_deadlines: Yup.string(),
        initial_notes: Yup.string(),
        determination: Yup.string(),
        records_received: Yup.string(),
        urgent: Yup.string(),
        overdue: Yup.string(),
        related_request: Yup.string()
    });

    // functions to build form returned by useForm() hook
    const { register, handleSubmit, reset, setValue, errors, formState } = useForm({
        resolver: yupResolver(validationSchema)
    });

    function onSubmit(data) {

        var c = [];
        for (var i in contacts) {
            var contact = new Object();
            contact.name = contacts[i].name;
            c.push(contact);
        }

        data.agency_contacts = c;
        data.submission_date = data.submission_date ? data.submission_date : null;
	  data.acknowledgement_date = data.acknowledgement_date ? data.acknowledgement_date : null;
        data.documents = documents;
        console.log("onSubmit: " + data.documents);
        console.log(JSON.stringify(data));
        return isAddMode
            ? createCase(data)
            : updateCase(id, data);
    }

    const fetchAgencies = () => {
        console.log("kekkaroth");
        return AxiosService.getAll("agencies").then(result => {
            const res = result.data;
            return res;
        });
    }

    function createCase(data) {
        return AxiosService.create(API_PATH, data)
            .then(() => {
                console.log(JSON.stringify(data));
                history.push('.');
            })
    }

    function deleteFile(name) {

        var filteredDocs = documents.filter(e => e !== name)
        setDocuments(filteredDocs);

        var files = [];
        for (var x in filteredDocs) {
            var file = new Object();
            file.name = filteredDocs[x];
            file.url = FILES_URL + file.name;
            files.push(file);
        }
        setFileInfos(files);
    }

    function updateCase(id, data) {
        return AxiosService.update(API_PATH, id, data)
            .then(() => {
                history.push('..');
            })
    }

    useEffect(() => {
        const user = AuthService.getCurrentUser();
        var documents = [];
        if (user) {
            setMod(user.roles.includes("ROLE_MODERATOR"));
            setAdmin(user.roles.includes("ROLE_ADMIN"));
        }
        AxiosService.getAll("contacts").then(x => setContactOptions(x.data));
        if (!isAddMode) {
            // get user and set form fields
            AxiosService.get(API_PATH, id).then(x => {
                var request = x.data;

                console.log("lawsuit: " + JSON.stringify(request.data));
                const fields = ['agency', 'agency_tracking_numbers', 'current_status', 'category', 'subject', 'short_description', 'submission_date', 'acknowledgement_date', 'response_deadline', 'expected_response_date', 'appeal_limit', 'appeal_deadlines', 'initial_notes', 'determination', 'agency_contacts', 'case_contacts', 'records_received', 'urgent', 'overdue', 'related_request'];
                fields.forEach(field => setValue(field, request[field]));

                console.log("req.agency" + request.agency);
                var value = new Object();
                value.name = request.agency;
                setSelectedAgency(value);

                setSelectedValueContact(request.agency_contacts);
                //fixes null for documents
                documents = request.documents == null ? [] : request.documents;
                setDocuments(documents);
                FileService.getFiles().then((response) => {
                    var files = [];
                    for (var x in documents) {
                        var doc = documents[x];
                        var file = new Object();
                        file.name = doc;
                        file.url = FILES_URL + doc;
                        files.push(file);
                    }
                    console.log("file infos: " + JSON.stringify(files));
                    setFileInfos(files); // previously response.data
                });
            })
        }

    }, []);

    $(document).ready(function () {
        $(document).on('focus', ':input', function () {
            $(this).attr('autocomplete', 'off');
        });
    });

    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)} onReset={reset}>
                <h1>{isAddMode ? 'Add Report' : 'Edit Report'}</h1>

                <div className="form-row">
                    <div
                        style={{ width: 250 }}>
                <label>Agency</label>
                <AsyncSelect
                    name="agency"
                    {...register("agency")}
                    cacheOptions
                    defaultOptions
                    searchable
                    value={selectedAgency}
                    getOptionLabel={e => e.name}
                    getOptionValue={e => e.name}
                    loadOptions={fetchAgencies}
                    onInputChange={handleInputChange}
                    onChange={handleChange}
                />
</div>
</div>
                <div className="form-row">
                    <div
                        style={{ width: 250 }}>
                        <label>Agency Contacts</label>
                        <Multiselect
                            options={contactOptions} // Options to display in the dropdown
                            selectedValues={selectedValueContact} // Preselected value to persist in dropdown
                            onSelect={onSelectContact} // Function will trigger on select event
                            onRemove={onRemoveContact} // Function will trigger on remove event
                            displayValue="name" // Property name to display in the dropdown options
                            closeOnSelect={true}
                            avoidHighlightFirstOption="true"
                        />
                    </div>
                </div>

                {/* Add 7-8 Rows*/}
                <div className="form-row">
                    <label>Agency Tracking Numbers:</label>
                    <textarea autoComplete="off" name="agency_tracking_numbers" rows={7} ref={register} className={`form-control ${errors.agency_tracking_numbers ? 'is-invalid' : ''}`} />
                </div>


                <div className="form-row">

                    <label>Current Status:</label>
                    <textarea autoComplete="off" name="current_status" rows={7} ref={register} className={`form-control ${errors.current_status ? 'is-invalid' : ''}`} />
                </div>


                {/* change to dropdown */}
                <div className="form-row">
                    <label>Subject:</label>
                    <textarea autoComplete="off" name="subject" rows={7} ref={register} className={`form-control ${errors.subject ? 'is-invalid' : ''}`} />
                </div>

                <div style={{ width: 450 }} className="form-row">
                    <label>Category:</label>
                    <select name="category" ref={register} className={`form-control ${errors.category ? 'is-invalid' : ''}`}>
                        <option value=""></option>
                        <option value="Active">Active</option>
                        <option value="Archive">Archive</option>
                        <option value="Litigation">Litigation</option>
                    </select>
                    <div className="invalid-feedback">{errors.category?.message}</div>
                </div>

                <div className="form-row">
                    <label>Short Description:</label>
                    <textarea autoComplete="off" name="short_description" rows={3} ref={register} className={`form-control ${errors.short_description ? 'is-invalid' : ''}`} />
                </div>

                <div className="form-row" style={{ width: 175 }}>
                    <label>Submission Date</label>
                    <input autoComplete="off" type="date" name="submission_date" ref={register} {...register("submission_date", {})} className={`form-control ${errors.submission_date ? 'is-invalid' : ''}`} />
                </div>

                <div className="form-row" style={{ width: 175 }}>
                    <label>Acknowledgement Date</label>
                    <input autoComplete="off" type="date" name="acknowledgement_date" ref={register} {...register("acknowledgement_date", {})} className={`form-control ${errors.acknowledgement_date ? 'is-invalid' : ''}`} />
                </div>



                {/* <div >
                    <label>Records Received:</label>
                    <input {...register("records_received")} style={{ position: 'relative', top: 0, }} type="radio" value="yes" name="records_received" /> Yes
                    <input {...register("records_received")} style={{ position: 'relative', top: 0, marginLeft: 15 }} type="radio" value="no" name="records_received" /> No
                </div>
                <div >
                    <label> Urgent?</label>
                    <input {...register("urgent")} style={{ position: 'relative', top: 0, }} type="radio" value="yes" name="urgent" /> Yes
                    <input {...register("urgent")} style={{ position: 'relative', top: 0, marginLeft: 15 }} type="radio" value="no" name="urgent" /> No
                </div>
                <div >
                    <label>Overdue?</label>
                    <input {...register("overdue")} style={{ position: 'relative', top: 0, }} type="radio" value="yes" name="overdue" /> Yes
                    <input {...register("overdue")} style={{ position: 'relative', top: 0, marginLeft: 15 }} type="radio" value="no" name="overdue" /> No
                </div> */}
                <div style={{ width: 450 }} className="form-group">
                    <label>Record received?:</label>
                    <select name="records_received" ref={register} className={`form-control ${errors.records_received ? 'is-invalid' : ''}`}>
                        <option value=""></option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                    <div className="invalid-feedback">{errors.category?.message}</div>
                </div>
                <div style={{ width: 450 }} className="form-group">
                    <label>Urgent?:</label>
                    <select name="urgent" ref={register} className={`form-control ${errors.urgent ? 'is-invalid' : ''}`}>
                        <option value=""></option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                    <div className="invalid-feedback">{errors.category?.message}</div>
                </div>
                <div style={{ width: 450 }} className="form-group">
                    <label>Overdue?:</label>
                    <select name="overdue" ref={register} className={`form-control ${errors.overdue ? 'is-invalid' : ''}`}>
                        <option value=""></option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                    <div className="invalid-feedback">{errors.category?.message}</div>
                </div>
                {/* documents file upload here */}
                <div className="form-group" style={{ marginTop: 25 }}>

                    {/* List all files */}


                    <div className="card">
                        <input type="file" onChange={selectFile} />
                        <br></br>
                        {message && <div className="alert alert-light" role="alert">
                            {message}
                        </div>}
                        <button
                            className="btn makeSmallbtn btn-success"
                            disabled={!selectedFiles}
                            onClick={upload}
                            style={{ marginBottom: 10 }}
                        >
                            Upload
                        </button>
                        {currentFile && (
                            <div className="progress">
                                <div
                                    className="progress-bar progress-bar-info progress-bar-striped"
                                    role="progressbar"
                                    aria-valuenow={progress}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                    style={{ width: progress + "%" }}
                                >
                                    {progress}%
                                </div>
                            </div>
                        )}
                        <div className="card-header">Documents</div>

                        <ul className="list-group list-group-flush">
                            <label className="btn btn-default">


                            </label>

                            {fileInfos && fileInfos.map((file, index) => (
                                <li className="list-group-item" key={index}>
                                    <a href={file.url}><AiIcons.AiOutlineFilePdf size={24} /> {file.name} </a>
                                    <button type="button" onClick={() => deleteFile(file.name)} className="btn btn-sm btn-danger mr-3"> <TbIcons.TbTrash size={24} />
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* radio buttons for Yes/No Lead Plaintiff Counsel? */}
                {/* radio buttons for Yes/No Lead Plaintiff Counsel? */}


                {/* <div className="form-row">
                    <div className="form-group col-5">
                        <label>Status *</label>
                        <select name="status" ref={register} className={`form-control ${errors.status ? 'is-invalid' : ''}`}>
                            <option value="Active">Active</option>
                            <option value="Archive">Archive</option>
                            <option value="Prospective">Prospective</option>
                        </select>
                        <div className="invalid-feedback">{errors.status?.message}</div>
                    </div>
                </div> */}


                <div className="form-group">
                    {(mod || admin) && (
                        <button type="submit" disabled={formState.isSubmitting} className="btn btn-primary">
                            {formState.isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                            Save
                        </button>
                    )}
                    <Link to={isAddMode ? '.' : '..'} className="btn btn-link">Cancel</Link>
                </div>
            </form >
            {/*
            typeof hasUnsavedChanges !== "undefined" && (
            <div>
                You have{" "}
                <strong
                    style={{
                        color: hasUnsavedChanges
                            ? "firebrick"
                            : "forestgreen",
                    }}
                >
                    {hasUnsavedChanges ? "not saved" : "saved"}
                </strong>{" "}
                your changes.
            </div>
                */}
        </div >

    );
}

export { AddEditRequest };